/**
 * Set element data
 * @param element
 * @param name
 * @param value
 */
export const setElementData = (element: HTMLElementTagNameMap['link'] | HTMLElementTagNameMap['script'] | null, name: string, value: string): boolean => {
    try {
        if (element && element instanceof HTMLElement && 'dataset' in element) {
            element.dataset[name] = value;
            return true;
        }
    } catch (error) {}
    return false;
};

/**
 * Get element data
 * @param element
 * @param name
 */
export const getElementData = (element: HTMLElementTagNameMap['link'] | HTMLElementTagNameMap['script'] | null, name: string): string | undefined => {
    try {
        if (element && element instanceof HTMLElement && 'dataset' in element) {
            return element.dataset[name];
        }
    } catch (error) {}
    return undefined;
};
